/* ==========================================================================
   KULTA — Sticky add-to-bag (mobile). Reusa el form/AJAX existente.
   Muestra la barra cuando el botón principal "Add to bag" sale de vista.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-kulta-sticky-atb]');
    if (!bar) return;
    bar.setAttribute('inert', '');

    var mainBtn = document.querySelector('.kulta-product-add');
    var form = mainBtn ? mainBtn.closest('form') : null;
    if (!mainBtn || !form) return;

    // mostrar la barra cuando el botón principal NO está en pantalla
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (show) bar.removeAttribute('inert');
          else bar.setAttribute('inert', '');
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    }

    // click en la barra = enviar el form real (dispara AJAX add + abre el drawer)
    var stickyBtn = bar.querySelector('[data-kulta-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainBtn.disabled) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          mainBtn.click();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
